import React from 'react';
import PracticeTestWrapper from '../../components/PracticeTest/PracticeTestWrapper';

export default function Practice() {
  return (
    <div>
      <PracticeTestWrapper />
    </div>
  );
}